import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6c55d67d")

_pushScopeId("data-v-6c55d67d")
const _hoisted_1 = { class: "hero pink-background block" }
const _hoisted_2 = { class: "hero-body" }
const _hoisted_3 = { class: "container is-fluid container-fullwidth" }
const _hoisted_4 = { class: "content-container block" }
const _hoisted_5 = { class: "json-display" }
const _hoisted_6 = { class: "content-container block has-text-centered mt-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")
  const _component_infigo_loading = _resolveComponent("infigo-loading")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("section", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Title, {
            title: "Order Place Confirmation Page",
            subtitle: "Thank you for your order!"
          }),
          _createVNode("div", _hoisted_4, [
            _createVNode("pre", _hoisted_5, _toDisplayString(_ctx.orderDetails), 1)
          ]),
          _createVNode("div", _hoisted_6, [
            _createVNode("button", {
              class: "button is-dark-infigo",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/shopping-list')))
            }, "Go to Basket")
          ])
        ])
      ])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_infigo_loading, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64))
})